import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("reliable-hero-section", {
    model: {
      defaults: {
        components: html`
          <section class=" relative mb-40">
            <div class="md:h-[700px] h-[400px]">
              <img
                src="https://via.placeholder.com/100"
                alt="Category_img"
                class="w-full h-full object-cover filter brightness-60"
              />
            </div>
            <div class="container mx-auto   px-4 md:px-12">
              <div
                class="text-white  flex flex-col justify-center gap-y-2  md:gap-y-10 bg-cover bg-center absolute md:top-36 top-16 conat z-10"
              >
                <h1
                  class="text-2xl md:text-6xl font-semibold leading-13 md:leading-20"
                >
                  Smart Cargo Solutions for a <br />Connected World
                </h1>
                <p class="md:text-2xl text-lg">
                  We guarantee fast, secure cargo transportation <br />worlwide.
                </p>
                <a href="/contact" class="p-1">
                  <button
                    class="px-3 py-2 bg-[#FA6914] rounded text-white flex items-center gap-x-4 "
                  >
                    <span class="text-lg">Get Estimation</span>
                    <svg
                      width="31"
                      height="30"
                      viewBox="0 0 31 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="0.780884"
                        width="29.6875"
                        height="28.7879"
                        rx="4"
                        fill="#FEFEFE"
                      />
                      <path
                        d="M9.75323 14.4481C9.35189 14.4481 9.02654 14.7735 9.02654 15.1748C9.02654 15.5761 9.35189 15.9015 9.75323 15.9015L9.75323 14.4481ZM21.4481 15.6887C21.7319 15.4049 21.7319 14.9447 21.4481 14.661L16.8235 10.0363C16.5397 9.75253 16.0795 9.75253 15.7958 10.0363C15.512 10.3201 15.512 10.7802 15.7958 11.064L19.9065 15.1748L15.7958 19.2856C15.512 19.5694 15.512 20.0295 15.7958 20.3133C16.0795 20.5971 16.5397 20.5971 16.8235 20.3133L21.4481 15.6887ZM9.75323 15.9015L20.9342 15.9015L20.9342 14.4481L9.75323 14.4481L9.75323 15.9015Z"
                        fill="#0083D7"
                      />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div
              class=" absolute -bottom-40 mb-4 w-full flex justify-center z-10  px-4"
            >
              <div
                class=" mx-auto w-full md:w-[70%] px-4 md:px-10 py-2 flex flex-col justify-evenly bg-white rounded-lg box-border shadow-lg "
              >
                <h3
                  class="md:pt-3 text-[10px] md:text-3xl font-bold tracking-normal text-center leading-normal font-roboto"
                >
                  OUR SERVICES
                </h3>
                <div
                  class="grid grid-cols-4 gap-3 items-center justify-items-center text-lg font-bold font-roboto md:mb-8"
                >
                  <a
                    href="air-transport"
                    class="p-2 md:p-4 flex flex-col items-center group hover:bg-[#FA6914] hover:text-white text-[#FA6914] hover:rounded-2xl"
                  >
                    <svg
                      class="md:w-20 w-12"
                      viewBox="0 0 86 86"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="3.22727"
                        y="3.22727"
                        width="79.5455"
                        height="79.5455"
                        rx="22.1591"
                        stroke="currentColor"
                        stroke-width="4.54545"
                      />
                      <path
                        d="M49.25 33.4594L74.25 49.25V55.5L49.25 47.6062V64.3562L58.625 69.5625V74.25L44.5625 71.125L30.5 74.25V69.5625L39.875 64.3531V47.6031L14.875 55.5V49.25L39.875 33.4594V16.4375C39.875 15.1943 40.3689 14.002 41.2479 13.1229C42.127 12.2439 43.3193 11.75 44.5625 11.75C45.8057 11.75 46.998 12.2439 47.8771 13.1229C48.7561 14.002 49.25 15.1943 49.25 16.4375V33.4594Z"
                        fill="currentColor"
                      />
                    </svg>

                    <div
                      class="text-[8px] text-[#0083D7] group-hover:text-white md:text-lg p-2"
                    >
                      <p class="text-center">Airways</p>
                      <p class="text-center">Transportation</p>
                    </div>
                  </a>
                  <a
                    href="road-transport"
                    class="p-2 md:p-4 flex flex-col items-center  group hover:bg-[#FA6914] hover:text-white text-[#FA6914] hover:rounded-2xl"
                  >
                    <svg
                      class="md:w-20 w-12"
                      viewBox="0 0 86 86"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="3.22727"
                        y="3.22727"
                        width="79.5455"
                        height="79.5455"
                        rx="22.1591"
                        stroke="currentColor"
                        stroke-width="4.54545"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M57.6875 15.5L71.75 71.75H15.5L28 15.5H57.6875ZM46.75 53H40.5V68.625H46.75V53ZM46.75 34.25H40.5V46.75H46.75V34.25ZM46.75 18.625H40.5V28H46.75V18.625Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div
                      class="text-[8px] text-[#0083D7] group-hover:text-white md:text-lg p-2"
                    >
                      <p class="text-center">Roadways</p>
                      <p class="text-center">Transportation</p>
                    </div>
                  </a>

                  <a
                    href="ocean-transport"
                    class="p-2 md:p-4 flex flex-col items-center  group hover:bg-[#FA6914] hover:text-white text-[#FA6914] hover:rounded-2xl"
                  >
                    <svg
                      class="md:w-20 w-12"
                      viewBox="0 0 86 86"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="3.22727"
                        y="3.22727"
                        width="79.5455"
                        height="79.5455"
                        rx="22.1591"
                        stroke="currentColor"
                        stroke-width="4.54545"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M49.9093 61.05C51.5338 60.2378 53.3159 59.7893 55.1314 59.7359C56.9469 59.6825 58.7523 60.0253 60.4218 60.7406L61.0905 61.0531L69.3968 65.2031C70.1103 65.5594 70.6606 66.1749 70.935 66.9237C71.2094 67.6725 71.1872 68.4978 70.8728 69.2308C70.5585 69.9637 69.9758 70.5487 69.2442 70.866C68.5126 71.1833 67.6873 71.2089 66.9374 70.9375L66.603 70.7938L58.2936 66.6406C57.5144 66.2511 56.6624 66.0287 55.7922 65.9878C54.922 65.9469 54.0528 66.0884 53.2405 66.4031L52.703 66.6406L48.5905 68.7C46.9653 69.5122 45.1826 69.9604 43.3665 70.0132C41.5504 70.0661 39.7446 69.7225 38.0749 69.0063L37.4093 68.7L33.2936 66.6406C32.5144 66.2511 31.6624 66.0287 30.7922 65.9878C29.922 65.9469 29.0528 66.0884 28.2405 66.4031L27.703 66.6406L19.3968 70.7969C18.6832 71.1577 17.8584 71.2313 17.0922 71.0025C16.326 70.7736 15.6767 70.2598 15.2779 69.5667C14.8791 68.8736 14.7612 68.054 14.9484 67.2766C15.1356 66.4992 15.6137 65.8231 16.2843 65.3875L16.603 65.2031L24.9093 61.05C26.5338 60.2378 28.3159 59.7893 30.1314 59.7359C31.9469 59.6825 33.7523 60.0253 35.4218 60.7406L36.0905 61.0531L40.203 63.1094C40.9827 63.4994 41.8352 63.722 42.706 63.7629C43.5768 63.8038 44.4465 63.6621 45.2593 63.3469L45.7936 63.1094L49.9093 61.05ZM46.1249 11.75C46.9537 11.75 47.7486 12.0792 48.3346 12.6653C48.9207 13.2513 49.2499 14.0462 49.2499 14.875V19L59.653 20.7313C61.1118 20.9753 62.4367 21.7288 63.3923 22.8577C64.3479 23.9866 64.8721 25.4178 64.8718 26.8969V37.6219L71.3093 39.7656C71.822 39.9367 72.2936 40.2122 72.6943 40.5749C73.0951 40.9376 73.4162 41.3795 73.6373 41.8726C73.8585 42.3658 73.9749 42.8995 73.9792 43.4399C73.9836 43.9804 73.8757 44.5159 73.6624 45.0125L66.8843 60.825L61.0905 57.925C59.3547 57.057 57.4406 56.6051 55.4999 56.6051C53.5592 56.6051 51.6451 57.057 49.9093 57.925L45.7936 59.9844C44.9257 60.4184 43.9687 60.6443 42.9983 60.6443C42.028 60.6443 41.0709 60.4184 40.203 59.9844L36.0905 57.925C34.3547 57.057 32.4406 56.6051 30.4999 56.6051C28.5592 56.6051 26.6451 57.057 24.9093 57.925L20.9405 59.9125L12.6343 45.3781C12.3475 44.8763 12.1757 44.3172 12.1312 43.741C12.0867 43.1648 12.1706 42.5859 12.3769 42.046C12.5831 41.5061 12.9066 41.0188 13.324 40.619C13.7414 40.2193 14.2423 39.9171 14.7905 39.7344L21.1249 37.6219V26.8969C21.1246 25.4178 21.6488 23.9866 22.6044 22.8577C23.5599 21.7288 24.8849 20.9753 26.3436 20.7313L36.7499 19V14.875C36.7499 14.0462 37.0791 13.2513 37.6652 12.6653C38.2512 12.0792 39.0461 11.75 39.8749 11.75H46.1249ZM42.9999 24.2938L27.3749 26.8969V35.5406L41.0218 30.9906C42.3048 30.5629 43.6919 30.5629 44.9749 30.9906L58.6249 35.5406V26.8969L42.9999 24.2938Z"
                        fill="currentColor"
                      />
                    </svg>

                    <div
                      class="text-[8px] text-[#0083D7] group-hover:text-white md:text-lg p-2"
                    >
                      <p class="text-center">Ocean</p>
                      <p class="text-center">Transportation</p>
                    </div>
                  </a>
                  <a
                    href="train-transport"
                    class="p-2 md:p-4 flex flex-col items-center  group hover:bg-[#FA6914] hover:text-white text-[#FA6914] hover:rounded-2xl"
                  >
                    <svg
                      class="md:w-20 w-12"
                      viewBox="0 0 86 86"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="3.22727"
                        y="3.22727"
                        width="79.5455"
                        height="79.5455"
                        rx="22.1591"
                        stroke="currentColor"
                        stroke-width="4.54545"
                      />
                      <path
                        d="M18.5 55.6875V26C18.5 23.2396 19.2167 21.0386 20.65 19.3969C22.0833 17.7552 23.9708 16.5052 26.3125 15.6469C28.6542 14.7886 31.324 14.2156 34.3219 13.9281C37.3198 13.6406 40.3792 13.4979 43.5 13.5C46.9375 13.5 50.1802 13.6438 53.2281 13.9313C56.276 14.2188 58.9323 14.7917 61.1969 15.65C63.4615 16.5084 65.2448 17.7584 66.5469 19.4C67.849 21.0417 68.5 23.2417 68.5 26V55.6875C68.5 58.7604 67.4458 61.3521 65.3375 63.4625C63.2292 65.5729 60.6375 66.6271 57.5625 66.625L59.125 68.1875C60.0104 69.0729 60.2188 70.0761 59.75 71.1969C59.2813 72.3177 58.4219 72.8771 57.1719 72.875C56.8073 72.875 56.4562 72.8104 56.1188 72.6813C55.7812 72.5521 55.4813 72.3563 55.2188 72.0938L49.75 66.625H37.25L31.7813 72.0938C31.5208 72.3542 31.2208 72.55 30.8813 72.6813C30.5417 72.8125 30.1917 72.8771 29.8313 72.875C28.6333 72.875 27.7875 72.3156 27.2938 71.1969C26.8 70.0781 26.9938 69.075 27.875 68.1875L29.4375 66.625C26.3646 66.625 23.7729 65.5709 21.6625 63.4625C19.5521 61.3542 18.4979 58.7625 18.5 55.6875ZM24.75 38.5H40.375V29.125H24.75V38.5ZM46.625 38.5H62.25V29.125H46.625V38.5ZM32.5625 57.25C33.9167 57.25 35.0365 56.8073 35.9219 55.9219C36.8073 55.0365 37.25 53.9167 37.25 52.5625C37.25 51.2084 36.8073 50.0886 35.9219 49.2031C35.0365 48.3177 33.9167 47.875 32.5625 47.875C31.2083 47.875 30.0885 48.3177 29.2031 49.2031C28.3177 50.0886 27.875 51.2084 27.875 52.5625C27.875 53.9167 28.3177 55.0365 29.2031 55.9219C30.0885 56.8073 31.2083 57.25 32.5625 57.25ZM54.4375 57.25C55.7917 57.25 56.9115 56.8073 57.7969 55.9219C58.6823 55.0365 59.125 53.9167 59.125 52.5625C59.125 51.2084 58.6823 50.0886 57.7969 49.2031C56.9115 48.3177 55.7917 47.875 54.4375 47.875C53.0833 47.875 51.9635 48.3177 51.0781 49.2031C50.1927 50.0886 49.75 51.2084 49.75 52.5625C49.75 53.9167 50.1927 55.0365 51.0781 55.9219C51.9635 56.8073 53.0833 57.25 54.4375 57.25Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div
                      class="text-[8px] text-[#0083D7] group-hover:text-white md:text-lg p-2"
                    >
                      <p class="text-center">Train</p>
                      <p class="text-center">Transportation</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>
        `,
      },
    },
  });
};
